module.exports = __webpack_public_path__ + "img/header-diamondJewelryEarrings@2x.9248872.webp";